<template>
  <dialog-view
      title="Удалить профиль"
      :open="open"
      @cancel="$emit('update:open', false)"
      content-full-size
  >
    <template v-slot:content>
          <v-list dense>
            <v-list-item v-for="(v, i) in salaryTemplates" :key="i" @click="remove(v)">
              <v-list-item-content>
                <v-list-item-title>{{v.name}}</v-list-item-title>
                <div v-if="!$tools.isEmpty(v.comment)" class="mt-1">
                  <v-icon small>mdi-comment-text-outline</v-icon>
                  <div class="caption mt-n5 ml-5">{{v.comment}}</div>
                </div>
              </v-list-item-content>
            </v-list-item>
          </v-list>
    </template>
  </dialog-view>
</template>

<script>
import DialogView from "@/components/DialogView.vue";
import axios from "axios";
import Api from "@/Api";
import {Entity_SalaryTemplate} from "../../../EntityStoreCacheService";


export default {
  components: {DialogView},
  props:['open'],
  data: () => ({
    salaryTemplates: []
  }),
  watch:{
    open() {
      if(this.open)
        this.salaryTemplatesLoad()
    }
  },
  methods: {
    salaryTemplatesLoad() {
      new Entity_SalaryTemplate()
          .selects(Entity_SalaryTemplate.id)
          .selects(Entity_SalaryTemplate.name)
          .selects(Entity_SalaryTemplate.comment)
          .selects(Entity_SalaryTemplate.createVisitMode)
          .selects(Entity_SalaryTemplate.createVisit)
          .selects(Entity_SalaryTemplate.renMode)
          .selects(Entity_SalaryTemplate.ren)
          .selects(Entity_SalaryTemplate.refMode)
          .selects(Entity_SalaryTemplate.ref)
          .selects(Entity_SalaryTemplate.regMode)
          .selects(Entity_SalaryTemplate.reg)
          .selects(Entity_SalaryTemplate.rateMode)
          .selects(Entity_SalaryTemplate.rate)
          .selects(Entity_SalaryTemplate.rateMaxMode)
          .selects(Entity_SalaryTemplate.rateMax)
          .selects(Entity_SalaryTemplate.isRateServiceDiscount)
          .selects(Entity_SalaryTemplate.isCountingFromMargin)

          .page(1)
          .onPage(1000)
          .order(Entity_SalaryTemplate.name, true)
          .request((v)=>{
              this.salaryTemplates = v.items;
          }, (e)=>{
            console.error(e.response.data.message);
          })
    },
    remove(v){
      axios.delete(Api.host+'/salary/template/'+v.id+'/').then(()=>{
        this.$emit('update:open', false);
        this.$store.commit('alertSuccess', 'Профиль удален');
      });
    }
  }
};
</script>